import { profileBusinessBase } from '../../megha/profile-business-dashboard/profile-route.util';
import { isProfileBusinessStoreType } from './profile-store-types.util';

export interface ProfileStoreLike {
  store_type?: string | null;
  store_code?: string | null;
}

/** First owned store that uses the profile business dashboard (list order from API). */
export function findPrimaryProfileBusinessStore<T extends ProfileStoreLike>(
  stores: T[] | null | undefined
): T | null {
  if (!stores?.length) return null;
  return (
    stores.find(
      (s) => isProfileBusinessStoreType(s.store_type) && String(s.store_code || '').trim()
    ) ?? null
  );
}

export function profileDashboardCommands(storeCode: string, storeType?: string | null): string[] {
  return profileBusinessBase(storeCode, storeType);
}
